/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

/**
 * The 'src' argument plays the command role.
 * The returned values is always of the same type as the 'src'.
 * @param dst
 * @param src
 * @returns {*}
 */
function mergeOne(dst, src) {
  if (src === undefined) { return dst; }

  // According to specification arrays must be concatenated.
  // Also, the '.concat' creates a new array instance. Overrides the 'dst'.
  if (isArray(src)) { return (isArray(dst) ? dst : []).concat(src); }

  // Now deal with non plain 'src' object. 'src' overrides 'dst'
  // Note that functions are also assigned! We do not deep merge functions.
  if (!isPlainObject(src)) { return src; }

  // See if 'dst' is allowed to be mutated. If not - it's overridden with a new plain object.
  var returnValue = isObject(dst) ? dst : {};

  var keys = Object.keys(src);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];

    var srcValue = src[key];
    // Do not merge properties with the 'undefined' value.
    if (srcValue !== undefined) {
      var dstValue = returnValue[key];
      // Recursive calls to mergeOne() must allow only plain objects or arrays in dst
      var newDst = isPlainObject(dstValue) || isArray(srcValue) ? dstValue : {};

      // deep merge each property. Recursion!
      returnValue[key] = mergeOne(newDst, srcValue);
    }
  }

  return returnValue;
}

var merge = function (dst) {
  var srcs = [], len = arguments.length - 1;
  while ( len-- > 0 ) srcs[ len ] = arguments[ len + 1 ];

  return srcs.reduce(mergeOne, dst);
};

function isFunction(obj) {
  return typeof obj === 'function';
}

function isObject(obj) {
  var type = typeof obj;
  return !!obj && (type === 'object' || type === 'function');
}

var assign = Object.assign || function assign(to) {
  var args = arguments;
  for (var s = 1; s < args.length; s += 1) {
    var from = args[s];
    if (from) {
      var keys = Object.keys(from);
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        to[key] = from[key];
      }
    }
  }

  return to;
};

var isArray = Array.isArray;

function isPlainObject(value) {
  return !!value && typeof value === 'object' &&
    Object.getPrototypeOf(value) === Object.prototype;
}


var concat = Array.prototype.concat;
function extractFunctions() {
  var fns = concat.apply([], arguments).filter(isFunction);
  return fns.length === 0 ? undefined : fns;
}

function concatAssignFunctions(dstObject, srcArray, propName) {
  if (!isArray(srcArray)) { return; }

  var length = srcArray.length;
  var dstArray = dstObject[propName] || [];
  dstObject[propName] = dstArray;
  for (var i = 0; i < length; i += 1) {
    var fn = srcArray[i];
    if (isFunction(fn) && dstArray.indexOf(fn) < 0) {
      dstArray.push(fn);
    }
  }
}


function combineProperties(dstObject, srcObject, propName, action) {
  if (!isObject(srcObject[propName])) { return; }
  if (!isObject(dstObject[propName])) { dstObject[propName] = {}; }
  action(dstObject[propName], srcObject[propName]);
}

function deepMergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, merge);
}
function mergeAssign(dstObject, srcObject, propName) {
  combineProperties(dstObject, srcObject, propName, assign);
}

/**
 * Converts stampit extended descriptor to a standard one.
 * @param [methods]
 * @param [properties]
 * @param [props]
 * @param [refs]
 * @param [initializers]
 * @param [init]
 * @param [deepProperties]
 * @param [deepProps]
 * @param [propertyDescriptors]
 * @param [staticProperties]
 * @param [statics]
 * @param [staticDeepProperties]
 * @param [deepStatics]
 * @param [staticPropertyDescriptors]
 * @param [configuration]
 * @param [conf]
 * @param [deepConfiguration]
 * @param [deepConf]
 * @param [composers]
 * @returns {Descriptor}
 */
var standardiseDescriptor = function (ref) {
  if ( ref === void 0 ) ref = {};
  var methods = ref.methods;
  var properties = ref.properties;
  var props = ref.props;
  var refs = ref.refs;
  var initializers = ref.initializers;
  var init = ref.init;
  var composers = ref.composers;
  var deepProperties = ref.deepProperties;
  var deepProps = ref.deepProps;
  var propertyDescriptors = ref.propertyDescriptors;
  var staticProperties = ref.staticProperties;
  var statics = ref.statics;
  var staticDeepProperties = ref.staticDeepProperties;
  var deepStatics = ref.deepStatics;
  var staticPropertyDescriptors = ref.staticPropertyDescriptors;
  var configuration = ref.configuration;
  var conf = ref.conf;
  var deepConfiguration = ref.deepConfiguration;
  var deepConf = ref.deepConf;

  var p = isObject(props) || isObject(refs) || isObject(properties) ?
    assign({}, props, refs, properties) : undefined;

  var dp = isObject(deepProps) ? merge({}, deepProps) : undefined;
  dp = isObject(deepProperties) ? merge(dp, deepProperties) : dp;

  var sp = isObject(statics) || isObject(staticProperties) ?
    assign({}, statics, staticProperties) : undefined;

  var dsp = isObject(deepStatics) ? merge({}, deepStatics) : undefined;
  dsp = isObject(staticDeepProperties) ? merge(dsp, staticDeepProperties) : dsp;

  var c = isObject(conf) || isObject(configuration) ?
    assign({}, conf, configuration) : undefined;

  var dc = isObject(deepConf) ? merge({}, deepConf) : undefined;
  dc = isObject(deepConfiguration) ? merge(dc, deepConfiguration) : dc;

  var ii = extractFunctions(init, initializers);

  var composerFunctions = extractFunctions(composers);
  if (composerFunctions) {
    dc = dc || {};
    concatAssignFunctions(dc, composerFunctions, 'composers');
  }

  var descriptor = {};
  if (methods) { descriptor.methods = methods; }
  if (p) { descriptor.properties = p; }
  if (ii) { descriptor.initializers = ii; }
  if (dp) { descriptor.deepProperties = dp; }
  if (sp) { descriptor.staticProperties = sp; }
  if (methods) { descriptor.methods = methods; }
  if (dsp) { descriptor.staticDeepProperties = dsp; }
  if (propertyDescriptors) { descriptor.propertyDescriptors = propertyDescriptors; }
  if (staticPropertyDescriptors) { descriptor.staticPropertyDescriptors = staticPropertyDescriptors; }
  if (c) { descriptor.configuration = c; }
  if (dc) { descriptor.deepConfiguration = dc; }

  return descriptor;
};

/**
 * Creates new factory instance.
 * @param {Descriptor} descriptor The information about the object the factory will be creating.
 * @returns {Function} The new factory function.
 */
function createFactory(descriptor) {
  return function Stamp(options) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    // Next line was optimized for most JS VMs. Please, be careful here!
    var obj = Object.create(descriptor.methods || null);

    merge(obj, descriptor.deepProperties);
    assign(obj, descriptor.properties);
    Object.defineProperties(obj, descriptor.propertyDescriptors || {});

    if (!descriptor.initializers || descriptor.initializers.length === 0) { return obj; }

    if (options === undefined) { options = {}; }
    var inits = descriptor.initializers;
    var length = inits.length;
    for (var i = 0; i < length; i += 1) {
      var initializer = inits[i];
      if (isFunction(initializer)) {
        var returnedValue = initializer.call(obj, options,
          {instance: obj, stamp: Stamp, args: [options].concat(args)});
        obj = returnedValue === undefined ? obj : returnedValue;
      }
    }

    return obj;
  };
}

/**
 * Returns a new stamp given a descriptor and a compose function implementation.
 * @param {Descriptor} [descriptor={}] The information about the object the stamp will be creating.
 * @param {Compose} composeFunction The "compose" function implementation.
 * @returns {Stamp}
 */
function createStamp(descriptor, composeFunction) {
  var Stamp = createFactory(descriptor);

  merge(Stamp, descriptor.staticDeepProperties);
  assign(Stamp, descriptor.staticProperties);
  Object.defineProperties(Stamp, descriptor.staticPropertyDescriptors || {});

  var composeImplementation = isFunction(Stamp.compose) ? Stamp.compose : composeFunction;
  Stamp.compose = function _compose() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return composeImplementation.apply(this, args);
  };
  assign(Stamp.compose, descriptor);

  return Stamp;
}

/**
 * Mutates the dstDescriptor by merging the srcComposable data into it.
 * @param {Descriptor} dstDescriptor The descriptor object to merge into.
 * @param {Composable} [srcComposable] The composable
 * (either descriptor or stamp) to merge data form.
 * @returns {Descriptor} Returns the dstDescriptor argument.
 */
function mergeComposable(dstDescriptor, srcComposable) {
  var srcDescriptor = (srcComposable && srcComposable.compose) || srcComposable;
  if (!isObject(srcDescriptor)) { return dstDescriptor; }

  mergeAssign(dstDescriptor, srcDescriptor, 'methods');
  mergeAssign(dstDescriptor, srcDescriptor, 'properties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'propertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticProperties');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'staticDeepProperties');
  mergeAssign(dstDescriptor, srcDescriptor, 'staticPropertyDescriptors');
  mergeAssign(dstDescriptor, srcDescriptor, 'configuration');
  deepMergeAssign(dstDescriptor, srcDescriptor, 'deepConfiguration');
  concatAssignFunctions(dstDescriptor, srcDescriptor.initializers, 'initializers');

  return dstDescriptor;
}

/**
 * Given the list of composables (stamp descriptors and stamps) returns
 * a new stamp (composable factory function).
 * @typedef {Function} Compose
 * @param {...(Composable)} [composables] The list of composables.
 * @returns {Stamp} A new stamp (aka composable factory function)
 */
function compose() {
  var composables = [], len = arguments.length;
  while ( len-- ) composables[ len ] = arguments[ len ];

  var descriptor = [this]
    .concat(composables)
    .filter(isObject)
    .reduce(mergeComposable, {});
  return createStamp(descriptor, compose);
}


/**
 * The Stamp Descriptor
 * @typedef {Function|Object} Descriptor
 * @returns {Stamp} A new stamp based on this Stamp
 * @property {Object} [methods] Methods or other data used as object instances' prototype
 * @property {Array<Function>} [initializers] List of initializers called for each object instance
 * @property {Object} [properties] Shallow assigned properties of object instances
 * @property {Object} [deepProperties] Deeply merged properties of object instances
 * @property {Object} [staticProperties] Shallow assigned properties of Stamps
 * @property {Object} [staticDeepProperties] Deeply merged properties of Stamps
 * @property {Object} [configuration] Shallow assigned properties of Stamp arbitrary metadata
 * @property {Object} [deepConfiguration] Deeply merged properties of Stamp arbitrary metadata
 * @property {Object} [propertyDescriptors] ES5 Property Descriptors applied to object instances
 * @property {Object} [staticPropertyDescriptors] ES5 Property Descriptors applied to Stamps
 */

/**
 * The Stamp factory function
 * @typedef {Function} Stamp
 * @returns {*} Instantiated object
 * @property {Descriptor} compose - The Stamp descriptor and composition function
 */

/**
 * A composable object - stamp or descriptor
 * @typedef {Stamp|Descriptor} Composable
 */

/**
 * Returns true if argument is a stamp.
 * @param {*} obj
 * @returns {Boolean}
 */
function isStamp(obj) {
  return isFunction(obj) && isFunction(obj.compose);
}

function createUtilityFunction(propName, action) {
  return function composeUtil() {
    var i = arguments.length, argsArray = Array(i);
    while ( i-- ) argsArray[i] = arguments[i];

    return ((this && this.compose) || stampit).call(this, ( obj = {}, obj[propName] = action.apply(void 0, [ {} ].concat( argsArray )), obj ));
    var obj;
  };
}

var methods = createUtilityFunction('methods', assign);

var properties = createUtilityFunction('properties', assign);
function initializers() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return ((this && this.compose) || stampit).call(this, {
    initializers: extractFunctions.apply(void 0, args)
  });
}
function composers() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return ((this && this.compose) || stampit).call(this, {
    composers: extractFunctions.apply(void 0, args)
  });
}

var deepProperties = createUtilityFunction('deepProperties', merge);
var staticProperties = createUtilityFunction('staticProperties', assign);
var staticDeepProperties = createUtilityFunction('staticDeepProperties', merge);
var configuration = createUtilityFunction('configuration', assign);
var deepConfiguration = createUtilityFunction('deepConfiguration', merge);
var propertyDescriptors = createUtilityFunction('propertyDescriptors', assign);

var staticPropertyDescriptors = createUtilityFunction('staticPropertyDescriptors', assign);

var allUtilities = {
  methods: methods,

  properties: properties,
  refs: properties,
  props: properties,

  initializers: initializers,
  init: initializers,

  composers: composers,

  deepProperties: deepProperties,
  deepProps: deepProperties,

  staticProperties: staticProperties,
  statics: staticProperties,

  staticDeepProperties: staticDeepProperties,
  deepStatics: staticDeepProperties,

  configuration: configuration,
  conf: configuration,

  deepConfiguration: deepConfiguration,
  deepConf: deepConfiguration,

  propertyDescriptors: propertyDescriptors,

  staticPropertyDescriptors: staticPropertyDescriptors
};

/**
 * Infected stamp. Used as a storage of the infection metadata
 * @type {Function}
 * @return {Stamp}
 */
var baseStampit = compose(
  {staticProperties: allUtilities},
  {
    staticProperties: {
      create: function create() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return this.apply(void 0, args);
      },
      compose: stampit // infecting
    }
  }
);

/**
 * Infected compose
 * @param {...(Composable)} [args] The list of composables.
 * @return {Stamp}
 */
function stampit() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var composables = args.filter(isObject)
    .map(function (arg) { return isStamp(arg) ? arg : standardiseDescriptor(arg); });

  // Calling the standard pure compose function here.
  var stamp = compose.apply(this || baseStampit, composables);

  var composerFunctions = stamp.compose.deepConfiguration &&
    stamp.compose.deepConfiguration.composers;
  if (isArray(composerFunctions) && composerFunctions.length > 0) {
    var uniqueComposers = [];
    for (var i = 0; i < composerFunctions.length; i += 1) {
      var composer = composerFunctions[i];
      if (isFunction(composer) && uniqueComposers.indexOf(composer) < 0) {
        uniqueComposers.push(composer);
      }
    }
    stamp.compose.deepConfiguration.composers = uniqueComposers;

    if (isStamp(this)) { composables.unshift(this); }
    for (var i$1 = 0; i$1 < uniqueComposers.length; i$1 += 1) {
      var composer$1 = uniqueComposers[i$1];
      var returnedValue = composer$1({stamp: stamp, composables: composables});
      stamp = isStamp(returnedValue) ? returnedValue : stamp;
    }
  }

  return stamp;
}

var exportedCompose = stampit.bind(); // bind to 'undefined'
stampit.compose = exportedCompose;

// Setting up the shortcut functions
var stampit$1 = assign(stampit, allUtilities);

exports.methods = methods;
exports.properties = properties;
exports.refs = properties;
exports.props = properties;
exports.initializers = initializers;
exports.init = initializers;
exports.composers = composers;
exports.deepProperties = deepProperties;
exports.deepProps = deepProperties;
exports.staticProperties = staticProperties;
exports.statics = staticProperties;
exports.staticDeepProperties = staticDeepProperties;
exports.deepStatics = staticDeepProperties;
exports.configuration = configuration;
exports.conf = configuration;
exports.deepConfiguration = deepConfiguration;
exports.deepConf = deepConfiguration;
exports.propertyDescriptors = propertyDescriptors;
exports.staticPropertyDescriptors = staticPropertyDescriptors;
exports.compose = exportedCompose;
exports['default'] = stampit$1;
module.exports = exports['default'];
//# sourceMappingURL=stampit.full.js.map


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
module.exports = __webpack_require__(7);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/stampit/dist/stampit.full.js
var stampit_full = __webpack_require__(0);
var stampit_full_default = /*#__PURE__*/__webpack_require__.n(stampit_full);

// CONCATENATED MODULE: ./src/frontend/js/map-api/google/utils-mixin.js


var UtilsMixin = stampit_full_default()({
  methods: {
    /**
     *
     * Creates latitude/longitude object
     *
     * @memberOf MapApi/Google/UtilsMixin
     * @instance
     *
     * @param {number} lat
     * @param {number} lng
     * @return {object} google.maps.LatLng object instance
     */
    createLatLng: function createLatLng(lat, lng) {
      return new google.maps.LatLng(lat, lng);
    }
  }
});

/**
 *
 * Google maps utils for use in
 * google map apis
 *
 * @mixin MapApi/Google/UtilsMixin
 */
/* harmony default export */ var utils_mixin = (UtilsMixin);
// CONCATENATED MODULE: ./src/frontend/js/map-api/google/map-api-factory.js



var PrivilegedMethods = stampit_full_default()().init(function () {
  var mapObj = void 0;

  /**
   *
   * Get map or return null if no map was created
   *
   * @memberOf module:MapApi/Google/MapApiFactory
   * @function getMap
   * @instance
   *
   * @return {object|null} google.maps.Map object instance
   */
  this.getMap = function getMap() {
    return mapObj || null;
  };

  /**
   *
   * Sets google map object value to be returned with getMap
   *
   * @memberOf module:MapApi/Google/MapApiFactory
   * @function setMap
   * @instance
   *
   * @param {object} map google.maps.Map object instance
   *
   */
  this.setMap = function setMap(map) {
    mapObj = map;
  };
});

var InitiateProps = stampit_full_default()({

  /**
   *
   * Initializes google maps handler with needed data.
   * Is called automatically with options passed to
   * main factory method / create method
   *
   * @ignore
   *
   * @param {object} opt object for initializing, see export below for all option parameters.
   * @param {object} opt.data
   * @param {object} [opt.options={}] additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapOptions|map options}
   *
   * @return void
   */
  init: function init(_ref, _ref2) {
    var data = _ref.data,
        options = _ref.options;
    var instance = _ref2.instance,
        stamp = _ref2.stamp,
        args = _ref2.args;

    this.data = data;
    this.options = options;
  },

  properties: {
    data: {},
    options: {}
  }
});

var PublicMethods = stampit_full_default()({

  methods: {
    /**
     *
     * Pans map to coordinates
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @param {number} lat
     * @param {number} lng
     *
     * @return {object} The instance on which this method was called.
     */
    panTo: function panTo(lat, lng) {
      var latLngObj = this.createLatLng(lat, lng);

      this.getMap().panTo(latLngObj);

      return this;
    },

    /**
     *
     * Gets center of map
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @return {object} google.maps.LatLng object instance
     */
    getCenter: function getCenter() {
      return this.getMap().getCenter();
    },

    /**
     *
     * Sets center of map
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @param {number} lat
     * @param {number} lng
     *
     * @return {object} The instance on which this method was called.
     */
    setCenter: function setCenter(lat, lng) {
      var latLngObj = this.createLatLng(lat, lng);

      this.getMap().setCenter(latLngObj);

      return this;
    },

    /**
     *
     * Adds map to DOM
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @return {object} The instance on which this method was called.
     */
    addMap: function addMap() {
      var latLng = void 0,
          mapOptions = void 0,
          map = void 0,
          mapDomEl = void 0,
          stylesObj = void 0,
          mapObj = void 0;

      mapOptions = this.getMapOptions();

      mapDomEl = document.getElementById(this.data.id);

      mapObj = new google.maps.Map(mapDomEl, mapOptions);

      this.setMap(mapObj);

      if (this.data.styles) {
        this.addMapStylesToMap();
      }

      return this;
    },

    /**
     *
     * Creates object of merged map options and returns it
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @return {object} map options object
     */
    getMapOptions: function getMapOptions() {
      var mapOptions = void 0,
          mapDataOptions = void 0,
          initialControlType = void 0,
          mapTypeControls = ['roadmap', 'satellite'],
          center = this.createLatLng(this.data.centerLat || 0, this.data.centerLng || 0),
          zoom = this.data.initialZoom ? Number(this.data.initialZoom) : 2,
          showZoomControl = Number(this.data.hideZoom) === 1 ? false : true,
          showStreetViewControl = Number(this.data.hideStreetView) === 1 ? false : true,
          showFullScreenControl = Number(this.data.hideFullScreen) === 1 ? false : true,
          showScaleControl = Number(this.data.hideScale) === 1 ? false : true,
          showRotateControl = Number(this.data.hideRotate) === 1 ? false : true,
          minZoom = this.data.minZoom ? Number(this.data.minZoom) : null,
          maxZoom = this.data.maxZoom ? Number(this.data.maxZoom) : null,
          gestureHandling = this.data.gestureHandling || 'cooperative';

      // Create array of map control types
      // from comma separated string
      if (this.data.controlTypes) {
        mapTypeControls = this.data.controlTypes.split(',').map(function (item) {
          return item.trim();
        });

        // If only one map type control option
        // exists, remove it to hide single control button
        if (mapTypeControls.length === 1) {
          mapTypeControls = [];
        }
      }

      // Check if a specific map type should be
      // active on initial render, otherwise choose
      // first in list
      if (this.data.controlInitType) {
        initialControlType = this.data.controlInitType;
      } else {
        initialControlType = mapTypeControls[0];
      }

      mapDataOptions = {
        center: center,
        zoom: zoom,
        minZoom: minZoom,
        maxZoom: maxZoom,
        mapTypeId: initialControlType,
        gestureHandling: gestureHandling,
        zoomControl: showZoomControl,
        streetViewControl: showStreetViewControl,
        fullscreenControl: showFullScreenControl,
        scaleControl: showScaleControl,
        rotateControl: showRotateControl,
        mapTypeControlOptions: {
          mapTypeIds: mapTypeControls
        }
      };

      // Merge options from data attributes with
      // any of the override options passed to init method
      mapOptions = Object.assign(mapDataOptions, this.options);

      return mapOptions;
    },

    /**
     *
     * Adds google.maps.StyledMapType to google maps object
     * and make style types selectable as map type
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @return void
     */
    addMapStylesToMap: function addMapStylesToMap() {
      var stylesObjArray = JSON.parse(this.data.styles),
          stylesLength = stylesObjArray.length,
          styledMapType = void 0,
          i = void 0,
          itemInLoop = void 0,
          map = this.getMap();

      for (i = 0; i < stylesLength; i++) {

        itemInLoop = stylesObjArray[i];

        styledMapType = new google.maps.StyledMapType(itemInLoop.style, {
          name: itemInLoop.name
        });

        map.mapTypes.set('styled_map_' + itemInLoop.id, styledMapType);
      }
    },

    /**
     *
     * Resizes map for proper rendering,
     * fx. if map container changes size
     *
     * @memberOf module:MapApi/Google/MapApiFactory
     * @instance
     *
     * @return {object} The instance on which this method was called.
     */
    resize: function resize() {
      google.maps.event.trigger(this.getMap(), 'resize');

      return this;
    },

    /**
     *
     * Map on ready function, triggered on 'idle', which accepts
     * callback. Event listener is only called once
     *
     * @param {function} cb callback
     * @return {object} The instance on which this method was called.
     */
    onReady: function onReady(cb) {
      var instance = this;

      google.maps.event.addListenerOnce(this.getMap(), 'idle', function onReadyCallback() {
        cb.call(instance);
      });

      return this;
    },

    /**
     *
     * Fit map bounds to array of items
     *
     * @param {object[]} items array of instances created with fx. {@link module:MapApi/Google/MarkerApiFactory|MapApi/Google/MarkerApiFactory}
     *
     * @return {object} The instance on which this method was called.
     */
    fitToItems: function fitToItems() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var bounds = new google.maps.LatLngBounds();

      items.forEach(function (item) {
        if (!item.isHidden()) {
          bounds.extend(item.getPosition());
        }
      });

      this.getMap().fitBounds(bounds);

      return this;
    }
  }
});

var MapApiFactory = stampit_full_default()(PrivilegedMethods, InitiateProps, PublicMethods, utils_mixin);

/**
 *
 * Google maps api factory created using stampit
 *
 * @module MapApi/Google/MapApiFactory
 * @mixes MapApi/Google/UtilsMixin
 *
 * Initializes google maps handler with needed data.
 *
 * @param {object}              opt                                          object for initializing. Note that opt.data keys are based on data-attribute names
 *                                                                           and are not the same as the actual google map option keys. The actual keys can be used
 *                                                                           via opt.options
 * @param {object}              opt.data
 * @param {string}              opt.data.id                                  map dom container id
 * @param {string|number}       [opt.data.centerLat=0]                       default center latitude of map
 * @param {string|number}       [opt.data.centerLng=0]                       default center longitude of map
 * @param {string|number}       [opt.data.minZoom=null]                      min zoom value of map
 * @param {string|number}       [opt.data.maxZoom=null]                      max zoom value of map
 * @param {string|number}       [opt.data.initialZoom=2]                     initial zoom value of map
 * @param {bool|string|number}  [opt.data.hideZoom=false]                    hide zoom controls
 * @param {bool|string|number}  [opt.data.hideStreetView=false]              hide streetview control
 * @param {bool|string|number}  [opt.data.hideFullScreen=false]              hide fullscreen control
 * @param {bool|string|number}  [opt.data.hideScale=false]                   hide scale control when zoomed in
 * @param {bool|string|number}  [opt.data.hideRotate=false]                  hide rotate control when zoomed in
 * @param {string}              [opt.data.gestureHandling=cooperative]       gesture handling setting
 * @param {string}              [opt.data.controlTypes='roadmap,satellite']  comma separated list of available control types
 * @param {string}              [opt.data.controlInitType='roadmap']         which control type to use on page load. Default is first in list of controlTypes
 * @param {object}              [opt.options={}]                             additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapOptions|map options},
 *                                                                           will override any existing options which were set via opt.data
 *
 * @example
 * import MapApiFactory from './map-api/google/map-api-factory'
 *
 * // or MapApiFactory.create({data, options});
 * let mapHandler = MapApiFactory({
 *   data: {
 *     id: 'some-id',
 *     hideFullScreen: '1'
 *   },
 *   options: {
 *     fullscreenControl: true // overrides opt.data.hideFullScreen
 *   }
 * });
 *
 * mapHandler.addMap(); // adds map to DOM
 *
 */
/* harmony default export */ var map_api_factory = (MapApiFactory);
// CONCATENATED MODULE: ./src/frontend/js/map-api/google/item-api-mixin.js



var item_api_mixin_PrivilegedMethods = stampit_full_default()().init(function () {
  var itemObj = void 0,
      infoWindowObj = void 0;

  /**
   *
   * Get item or return null if no item was created
   *
   * @memberOf MapApi/Google/ItemApiMixin
   * @function getItem
   * @instance
   *
   * @return {object} google maps item instance: marker, polygon etc.
   */
  this.getItem = function () {
    return itemObj || null;
  };

  /**
   *
   * Set main item object
   *
   * @memberOf MapApi/Google/ItemApiMixin
   * @function setItem
   * @instance
   *
   * @param {object} item google maps item instance: marker, polygon etc.
   * @return {object} The instance on which this method was called
   */
  this.setItem = function (item) {
    itemObj = item;

    return this;
  };

  /**
   *
   * Get infoWindow of item
   *
   * @memberOf MapApi/Google/ItemApiMixin
   * @function getInfoWindow
   * @instance
   *
   * @return {object|null} google.maps.InfoWindow object instance
   */
  this.getInfoWindow = function () {
    return infoWindowObj || null;
  };

  /**
   *
   * Set infoWindow of item
   *
   * @memberOf MapApi/Google/ItemApiMixin
   * @function setInfoWindow
   * @instance
   *
   * @param {object} google.maps.InfoWindow object instance
   *
   * @return {object} The instance on which this method was called
   */
  this.setInfoWindow = function (infoWindow) {
    infoWindowObj = infoWindow;

    return this;
  };
});

var item_api_mixin_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Add marker info window and click event listener
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @param {string} content html content
     * @param {object} [options={}] additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindowOptions|infoWindow options}
     *
     * @return {object} The instance on which this method was called
     */
    addInfoWindow: function addInfoWindow(content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var infoWindow = void 0,
          item = this.getItem(),
          map = this.getMap(),
          mergedOptions = void 0,
          instance = this;

      mergedOptions = Object.assign({
        content: content
      }, options);

      infoWindow = new google.maps.InfoWindow(mergedOptions);

      this.setInfoWindow(infoWindow);

      item.addListener('click', function () {
        instance.getInfoWindow().open(map, item);
      });

      return this;
    },

    /**
     *
     * Opens item window if one exists
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    openWindow: function openWindow() {
      var w = this.getInfoWindow();

      if (w) {
        w.open(this.getMap(), this.getItem());
      }

      return this;
    },

    /**
     *
     * Closes item window if one exists
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    closeWindow: function openWindow() {
      var w = this.getInfoWindow();

      if (w) {
        w.close();
      }

      return this;
    },

    /**
     *
     * Get map to which item is currently attached
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {object|null} google.maps.Map object instance
     */
    getMap: function getMap() {
      var item = this.getItem(),
          map = void 0;

      if (item) {
        map = item.getMap();
      }

      return map || null;
    },

    /**
     *
     * Set map of item
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @param {object} google.maps.Map object instance
     *
     * @return {object} The instance on which this method was called
     */
    setMap: function setMap(map) {
      var item = this.getItem();

      if (item) {
        item.setMap(map);
      }

      return this;
    },

    /**
     *
     * Show item
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    show: function show() {
      this.getItem().setVisible(true);

      return this;
    },

    /**
     *
     * Hide item
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    hide: function hide() {
      this.getItem().setVisible(false);

      return this;
    },

    /**
     *
     * Checks if item is hidden
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {bool} if item is hidden or not
     */
    isHidden: function isHidden() {
      var hidden = !this.isVisible();

      return hidden;
    },

    /**
     *
     * Checks if item is visible
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @return {bool} if item is visible or not
     */
    isVisible: function isVisible() {
      var visible = this.getItem().getVisible();

      return visible;
    },

    /**
     *
     * Set options of item
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @param {object} options all available google maps item options
     * @see fx https://developers.google.com/maps/documentation/javascript/3.exp/reference#MarkerOptions
     *
     * @return {object} The instance on which this method was called
     */
    setOptions: function setOptions(options) {
      if (options) {
        this.getItem().setOptions(options);
      }

      return this;
    },

    /**
     *
     * Parses options object and converts values to instances
     * of google.maps.Point and google.maps.Size
     *
     * @memberOf MapApi/Google/ItemApiMixin
     * @instance
     *
     * @param {object}   options                options object
     * @param {string}   options.url            url of icon
     * @param {number[]} [options.size]         natural width/height of icon, fx [40,80]
     * @param {number[]} [options.scaledSize]   scaled width/height of icon, fx [20,40] for 50% scaling
     * @param {number[]} [options.anchor]       xy coordinates of marker anchor relative to icon & scale, fx [20,40]
     * @param {number[]} [options.origin]       xy coordinates of icon on image, fx [0,100]. Mainly used when icon image is a sprite
     * @param {number[]} [options.labelOrigin]  xy coordinates of label relative to icon
     *
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Icon
     *
     * @return {object}  parsed object which can be used as icon
     */
    createIcon: function createIcon(options) {

      var parsedOptions = void 0;

      if (options && options.url) {

        var size = options.size,
            scaledSize = options.scaledSize,
            anchor = options.anchor,
            origin = options.origin,
            labelOrigin = options.labelOrigin;

        parsedOptions = {
          url: options.url
        };

        if (size) {
          parsedOptions.size = new google.maps.Size(size[0], size[1]);
        }

        if (scaledSize) {
          parsedOptions.scaledSize = new google.maps.Size(scaledSize[0], scaledSize[1]);
        }

        if (anchor) {
          parsedOptions.anchor = new google.maps.Point(anchor[0], anchor[1]);
        }

        if (origin) {
          parsedOptions.origin = new google.maps.Point(origin[0], origin[1]);
        }

        if (labelOrigin) {
          parsedOptions.labelOrigin = new google.maps.Point(labelOrigin[0], labelOrigin[1]);
        }
      }

      return parsedOptions;
    }
  }
});

var ItemApiMixin = stampit_full_default()(item_api_mixin_PrivilegedMethods, item_api_mixin_PublicMethods, utils_mixin);

/**
 *
 * Google item api mixin created using stampit.
 *
 * Serves as base mixin for all google map item type
 * factories like markers, polygons etc.
 *
 * @mixin MapApi/Google/ItemApiMixin
 *
 * @example
 * import ItemApiMixin from './map-api/google/item-api-mixin';
 *
 * // create new item type factory
 * let NewItemStamp = stampit(ItemApiMixin, SomeNewProps, SomeNewMethods)
 *
 * let newItemHandler = NewItemStamp.create()
 */
/* harmony default export */ var item_api_mixin = (ItemApiMixin);
// CONCATENATED MODULE: ./src/frontend/js/map-api/google/marker-api-factory.js



var marker_api_factory_InitiateProps = stampit_full_default()({

  /**
   *
   * Creates google maps marker
   *
   * @memberOf module:MapApi/Google/MarkerApiFactory
   * @instance
   *
   * @ignore
   *
   * @param {object} opt object for initializing, see export below for all option parameters.
   * @param {object} opt.data
   * @param {object} [opt.options={}]  additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MarkerOptions|marker options}
   *
   * @return {object} The instance on which this method was called
   */
  init: function init(_ref, _ref2) {
    var data = _ref.data,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;
    var instance = _ref2.instance,
        stamp = _ref2.stamp,
        args = _ref2.args;

    var markerLatLng = void 0,
        marker = void 0,
        mergedOptions = void 0,
        anchorPoint = void 0,
        defaultOptions = void 0;

    this.data = data;
    this.options = options;

    // Create latLng object
    markerLatLng = this.createLatLng(data.lat, data.lng);

    defaultOptions = {
      position: markerLatLng,
      map: data.map
    };

    // Create icon
    if (data.icon) {
      defaultOptions.icon = this.createIcon(data.icon);
    }

    // If icon data contains anchorPoint values for
    // correct positioning of infowindow, add value to marker options
    if (data.icon && data.icon.anchorPoint) {
      defaultOptions.anchorPoint = new google.maps.Point(data.icon.anchorPoint[0], data.icon.anchorPoint[1]);
    }

    mergedOptions = Object.assign(defaultOptions, options);

    marker = new google.maps.Marker(mergedOptions);

    this.setItem(marker);

    return this;
  },

  properties: {
    data: {},
    options: {}
  }
});

var marker_api_factory_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Get marker lat/lng position object
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @return {object} google.maps.LatLng object instance
     */
    getPosition: function getPosition() {
      return this.getItem().getPosition();
    },

    /**
     *
     * Set position of marker using options object
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @param {object} options      lat/lng
     * @param {number} options.lat  latitude
     * @param {number} options.lng  longitude
     *
     * @return {object} The instance on which this method was called
     */
    setPosition: function setPosition(options) {
      var markerLatLng = this.createLatLng(options.lat, options.lng);

      this.getItem().setPosition(markerLatLng);

      return this;
    },

    /**
     *
     * Set icon of marker
     *
     * @memberOf module:MapApi/Google/MarkerApiFactory
     * @instance
     *
     * @param {object} options {@link MapApi/Google/ItemApiMixin#createIcon| see createIcon method for parameters}
     *
     * @return {object} The instance on which this method was called
     */
    setIcon: function setIcon(options) {
      var icon = this.createIcon(options);

      this.getItem().setIcon(icon);

      // If icon options contains anchorPoint values for
      // correct positioning of infowindow, set anchorPoint option of marker
      if (options.anchorPoint) {
        var anchorPoint = new google.maps.Point(options.anchorPoint[0], options.anchorPoint[1]);
        this.setOptions({ 'anchorPoint': anchorPoint });
      }

      return this;
    }
  }
});

var MarkerApiFactory = stampit_full_default()(item_api_mixin, marker_api_factory_InitiateProps, marker_api_factory_PublicMethods);

/**
 *
 * Google marker api factory created using stampit
 *
 * @module MapApi/Google/MarkerApiFactory
 * @mixes MapApi/Google/ItemApiMixin
 *
 * @param {object} opt               object for initializing. Note that opt.data keys are based on data-attribute names
 *                                   and are not the same as the actual google map option keys. The actual keys can be used
 *                                   via opt.options
 *
 * @param {object} opt.data
 * @param {number} opt.data.lat      latitude
 * @param {number} opt.data.lng      longitude
 * @param {object} opt.data.map      map to attach marker to, instance of google.maps.Map
 * @param {object} [opt.data.icon]   see {@link MapApi/Google/ItemApiMixin#createIcon|createIcon method}
 * @param {object} [opt.options={}]  additional {@link https://developers.google.com/maps/documentation/javascript/3.exp/reference#MarkerOptions|marker options},
 *                                   will override any existing options which were set via opt.data
 *
 * @example
 * import MarkerApiFactory from './map-api/google/marker-api-factory'
 *
 * // or MarkerApiFactory.create({data, options});
 * let markerHandler = MarkerApiFactory({
 *   data:{
 *     lat: markerData.lat,
 *     lng: markerData.lng,
 *     map: mapHandler.getMap(),
 *     icon: {
 *       anchor: [12, 40],
 *       anchorPoint: [0, -40],
 *       scaledSize: [24, 40],
 *       size: [48, 80],
 *       url: '/fileadmin/content/test-assets/maps/icons/marker-icon-2x.png'
 *     }
 *   }, options: {}
 * }).addInfoWindow(htmlString);
 */
/* harmony default export */ var marker_api_factory = (MarkerApiFactory);
// CONCATENATED MODULE: ./src/frontend/js/map-api/collection-factory.js


var collection_factory_PrivilegedMethods = stampit_full_default()().init(function () {
  var collection = {};

  /**
   *
   * Adds item to collection
   *
   * @memberOf module:MapApi/CollectionFactory
   * @instance
   *
   * @param {string} id item identifier in collection
   * @param {object} item instance
   *
   * @return void
   */
  this.addItem = function addItem(id, item) {

    collection[id] = item;
  };

  /**
   *
   * Remove item from collection based on id
   * and optionally remove it from map
   *
   * @memberOf module:MapApi/CollectionFactory
   * @instance
   *
   * @param {string} id
   * @param {bool} [removeFromMap=true] if item should be removed from map
   * @return void
   */
  this.removeItem = function removeItem(id) {
    var removeFromMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


    if (removeFromMap) {
      collection[id].setMap(null);
    }

    delete collection[id];
  };

  /**
   *
   * Get collection of item instances
   *
   * @memberOf module:MapApi/CollectionFactory
   * @instance
   *
   * @return {object} collection of items
   */
  this.getCollection = function getCollection() {
    return collection;
  };
});

var collection_factory_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Hide all items in collection by calling hide method
     * of all item instances.
     *
     * @memberOf module:MapApi/CollectionFactory
     * @instance
     *
     * @return void
     */
    hide: function hide() {
      var col = this.getCollection();

      for (var key in col) {
        if (col.hasOwnProperty(key)) {
          var item = col[key];

          item.hide();

          if (typeof item.closeWindow === 'function') {
            item.closeWindow();
          }
        }
      }
    },

    /**
     *
     * Show all items in collection by calling show method
     * of all item instances.
     *
     * @memberOf module:MapApi/CollectionFactory
     * @instance
     *
     * @return void
     */
    show: function show() {
      var col = this.getCollection();

      for (var key in col) {
        if (col.hasOwnProperty(key)) {
          col[key].show();
        }
      }
    },

    /**
     *
     * Get item from collection based on id
     *
     * @memberOf module:MapApi/CollectionFactory
     * @instance
     *
     * @param {string} id id of item
     * @return {object} item instance created with fx. {@link module:MapApi/Google/MarkerApiFactory|MapApi/Google/MarkerApiFactory}
     */
    getItem: function getItem(id) {
      return this.getCollection()[id] || null;
    },

    /**
     *
     * Get all items from collection
     *
     * @memberOf module:MapApi/CollectionFactory
     * @instance
     *
     * @return {object[]} array of item instances created with fx. {@link module:MapApi/Google/MarkerApiFactory|MapApi/Google/MarkerApiFactory}
     */
    getAllItems: function getAllItems() {
      var col = this.getCollection(),
          itemsArray = [];

      for (var key in col) {
        if (col.hasOwnProperty(key)) {
          itemsArray.push(col[key]);
        }
      }

      return itemsArray;
    }
  }
});

var CollectionFactory = stampit_full_default()(collection_factory_PrivilegedMethods, collection_factory_PublicMethods);

/**
 *
 * Google maps collection manager factory
 *
 * @module MapApi/CollectionFactory
 *
 * @example
 * import CollectionFactory from './map-api/collection-factory'
 *
 * // or CollectionFactory.create();
 * let collection = CollectionFactory();
 *
 * // Add marker instance to collection
 * collection.addItem('idString', markerApiInstance);
 *
 */
/* harmony default export */ var collection_factory = (CollectionFactory);
// CONCATENATED MODULE: ./src/frontend/js/map-api/collection-manager-factory.js



var collection_manager_factory_InitiateProps = stampit_full_default()({

  /**
   *
   *
   * @ignore
   *
   * @return void
   */
  init: function init() {
    this.collections = {};
  },

  properties: {
    collections: null
  }
});

var collection_manager_factory_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Adds new collection
     *
     * @memberOf module:MapApi/CollectionManagerFactory
     * @instance
     * @todo add check if collection already exists
     *
     * @param {string} key collection key
     * @return {object} instance created with {@link module:MapApi/CollectionFactory|MapApi/CollectionFactory}
     */
    addCollection: function addCollection(key) {
      var collection = collection_factory();

      if (!this.collectionExists(key)) {
        this.collections[key] = collection;
      }
      return collection;
    },

    /**
     *
     * Retrieves collection
     *
     * @memberOf module:MapApi/CollectionManagerFactory
     * @instance
     *
     * @param {string} key collection key
     * @return {object} instance created with {@link module:MapApi/CollectionFactory|MapApi/CollectionFactory}
     */
    getCollection: function getCollection(key) {
      var collection = null;

      if (this.collectionExists(key)) {
        collection = this.collections[key];
      }

      return collection;
    },

    /**
     *
     * Deletes collection
     *
     * @memberOf module:MapApi/CollectionManagerFactory
     * @instance
     * @todo add option to delete items in collection?
     *
     * @param {string} key collection key
     * @return void
     */
    removeCollection: function removeCollection(key) {
      delete this.collections[key];
    },

    /**
     *
     * Checks if collection exists
     *
     * @memberOf module:MapApi/CollectionManagerFactory
     * @instance
     *
     * @param {string} key collection key
     * @return {bool}
     */
    collectionExists: function collectionExists(key) {
      return this.collections[key] ? true : false;
    }
  }
});

var CollectionManagerFactory = stampit_full_default()(collection_manager_factory_InitiateProps, collection_manager_factory_PublicMethods);

/**
 *
 * Collection manager factory
 *
 * @module MapApi/CollectionManagerFactory
 *
 * @example
 * import CollectionManagerFactory from './map-api/collection-manager-factory'
 *
 * let collectionManager = CollectionManagerFactory.create();
 *
 * // Add new collection to manager
 * let markerCollection = collectionManager.addCollection('markers');
 *
 */
/* harmony default export */ var collection_manager_factory = (CollectionManagerFactory);
// CONCATENATED MODULE: ./src/frontend/js/map-api/leaflet/utils-mixin.js


var utils_mixin_UtilsMixin = stampit_full_default()({
  methods: {
    /**
     *
     * Creates latitude/longitude object
     *
     * @param {number} lat
     * @param {number} lng
     * @return {object} leaflet L.latLng object
     */
    createLatLng: function createLatLng(lat, lng) {
      return L.latLng(lat, lng);
    }
  }
});

/**
 *
 * Leaflet maps utils for use in
 * leaflet map apis
 *
 * @mixin MapApi/Leaflet/UtilsMixin
 */
/* harmony default export */ var leaflet_utils_mixin = (utils_mixin_UtilsMixin);
// CONCATENATED MODULE: ./src/frontend/js/map-api/leaflet/map-api-factory.js



var map_api_factory_PrivilegedMethods = stampit_full_default()().init(function () {
  var mapObj = void 0;

  /**
   *
   * Get map or return null if no map was created
   *
   * @memberOf module:MapApi/Leaflet/MapApiFactory
   * @function getMap
   * @instance
   *
   * @return {object|null} L.map leaflet maps instance
   */
  this.getMap = function getMap() {
    return mapObj || null;
  };

  /**
   *
   * Sets leaflet map instance value to be returned with getMap
   *
   * @memberOf module:MapApi/Leaflet/MapApiFactory
   * @function setMap
   * @instance
   *
   * @param {object} L.map leaflet maps instance
   * @return void
   */
  this.setMap = function setMap(map) {
    mapObj = map;
  };
});

var map_api_factory_InitiateProps = stampit_full_default()({

  /**
   *
   * Initializes leaflet maps handler with needed data.
   * Is called automatically with options passed to
   * main factory method / create method
   *
   * @ignore
   *
   * @param {object} opt object for initializing, see export below for all option parameters.
   * @param {object} opt.data
   * @param {object} [opt.options={}] additional {@link http://leafletjs.com/reference-1.2.0.html#map|map options}
   *
   * @return void
   */
  init: function init(_ref, _ref2) {
    var data = _ref.data,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;
    var instance = _ref2.instance,
        stamp = _ref2.stamp,
        args = _ref2.args;

    this.data = data;
    this.options = options;
  },

  properties: {
    data: {},
    options: {}
  }
});

var map_api_factory_PublicMethods = stampit_full_default()({

  methods: {
    /**
     *
     * Pans map to coordinates
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @param {number} lat
     * @param {number} lng
     *
     * @return {object} The instance on which this method was called.
     */
    panTo: function panTo(lat, lng) {
      var latLngObj = this.createLatLng(lat, lng);

      this.getMap().panTo(latLngObj, { animate: false });

      return this;
    },

    /**
     *
     * Adds map to DOM
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @return {object} The instance on which this method was called.
     */
    addMap: function addMap() {

      var mapObj = void 0,
          mapId = this.data.id,
          mapOptions = void 0,
          tileLayerOptions = void 0,
          mapDataOptions = void 0,
          mapBounds = void 0;

      // Set map options
      mapOptions = this.getMapOptions();

      // If map uses a raster tile layer, we need to create
      // map bounds based on said layer size
      if (this.data.tilesPath) {

        // Create map object
        mapObj = L.map(mapId, mapOptions).setView([0, 0], mapOptions.zoom);

        mapBounds = L.latLngBounds(mapObj.unproject([0, this.data.height], mapOptions.maxZoom), mapObj.unproject([this.data.width, 0], mapOptions.maxZoom));

        tileLayerOptions = this.getTileLayerOptions();

        L.tileLayer(this.data.tilesPath + '{z}/{x}/{y}.png', tileLayerOptions).addTo(mapObj);

        // Fit bounds with value calculated above, and set
        // zoom value after, as map init zoom option is overridden when fitting to bounds
        mapObj.fitBounds(mapBounds, { animate: false }).setZoom(mapOptions.zoom, { animate: false });
      } else {

        // Create map object
        mapObj = L.map(mapId, mapOptions).setView(mapOptions.center, mapOptions.zoom);

        L.tileLayer(this.data.tileServerUrl, {
          minZoom: mapOptions.minZoom,
          maxZoom: mapOptions.maxZoom,
          attribution: this.data.attribute || ''
        }).addTo(mapObj);
      }

      this.setMap(mapObj);

      return this;
    },

    /**
     *
     * Creates object of merged tilelayer options and returns it
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @return {object} tilelayer options object
     */
    getTileLayerOptions: function getTileLayerOptions() {
      var tileLayerOptions = void 0,

      //mergedTilelayerOptions,
      minZoom = this.data.minZoom || 2,
          maxZoom = this.data.maxZoom || 6,
          attribute = this.data.attribute || '';

      tileLayerOptions = {
        minZoom: minZoom,
        maxZoom: L.Browser.retina ? maxZoom + 1 : maxZoom,
        attribution: attribute,
        noWrap: true,
        detectRetina: 1,
        errorTileUrl: '/typo3conf/ext/ksgtheme/Resources/Public/dist/img/blank-tile.png'
      };

      //mergedTilelayerOptions = Object.assign(tileLayerOptions, this.options);

      return tileLayerOptions;
    },

    /**
     *
     * Creates object of merged map options and returns it
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @return {object} map options object
     */
    getMapOptions: function getMapOptions() {
      var mapDataOptions = void 0,
          mergedMapOptions = void 0,
          zoom = this.data.initialZoom || undefined,
          minZoom = this.data.minZoom || undefined,
          maxZoom = this.data.maxZoom || undefined,
          zoomControl = Number(this.data.hideZoom) === 1 ? false : true,
          attributionControl = Number(this.data.hideAttribution) === 1 ? false : true,
          doubleClickZoom = Number(this.data.disableDoubleClick) === 1 ? false : true,
          scrollWheelZoom = Number(this.data.disableScrollZoom) === 1 ? false : true,
          dragging = Number(this.data.disableDragging) === 1 ? false : true,
          touchZoom = Number(this.data.disableTouchZoom) === 1 ? false : true,
          center = this.createLatLng(this.data.centerLat || 0, this.data.centerLng || 0);

      mapDataOptions = {
        center: center,
        zoom: zoom,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomControl: zoomControl,
        attributionControl: attributionControl,
        doubleClickZoom: doubleClickZoom,
        dragging: dragging,
        scrollWheelZoom: scrollWheelZoom,
        touchZoom: touchZoom,
        // always set to false to prevent
        // state where map disappears when zoomed
        // too far out
        bounceAtZoomLimits: false,
        crs: L.CRS.Simple
      };

      mergedMapOptions = Object.assign(mapDataOptions, this.options);

      return mergedMapOptions;
    },

    /**
     *
     * Gets center of map
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @return {object} L.latLng object instance
     */
    getCenter: function getCenter() {
      return this.getMap().getCenter();
    },

    /**
     *
     * Sets center of map
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @param {number} lat
     * @param {number} lng
     *
     * @return {object} The instance on which this method was called.
     */
    setCenter: function setCenter(lat, lng) {
      this.panTo(lat, lng);

      return this;
    },

    /**
     *
     * Resizes map for proper rendering,
     * fx. if map container changes size
     *
     * @memberOf module:MapApi/Leaflet/MapApiFactory
     * @instance
     *
     * @return {object} The instance on which this method was called.
     */
    resize: function resize() {
      this.getMap().invalidateSize();

      return this;
    },

    /**
     *
     * Map on ready function, triggered on 'idle', which accepts
     * callback. Event listener is only called once
     *
     * @param {function} cb callback
     * @return {object} The instance on which this method was called.
     */
    onReady: function onReady(cb) {
      var instance = this;

      this.getMap().whenReady(function onReadyCallback() {
        cb.call(instance);
      });

      return this;
    },

    /**
     *
     * Fit map bounds to array of items
     *
     * @param {object[]} items array of instances created with fx. {@link module:MapApi/Leaflet/MarkerApiFactory|MapApi/Leaflet/MarkerApiFactory}
     *
     * @return {object} The instance on which this method was called.
     */
    fitToItems: function fitToItems() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (items.length) {

        var map = this.getMap(),
            leafletItemsArray = void 0;

        leafletItemsArray = items.map(function (el) {
          return el.getItem();
        });

        // Fit to item bounds and zoom out an extra step,
        // to ensure all markers are visible
        map.fitBounds(L.featureGroup(leafletItemsArray).getBounds(), { animate: false }).setZoom(map.getZoom() - 1, { animate: false });
      }

      return this;
    }
  }

});

var map_api_factory_MapApiFactory = stampit_full_default()(map_api_factory_PrivilegedMethods, map_api_factory_InitiateProps, map_api_factory_PublicMethods, leaflet_utils_mixin);

/**
 *
 * Leaflet maps api factory created using stampit
 *
 * @module MapApi/Leaflet/MapApiFactory
 * @mixes MapApi/Leaflet/UtilsMixin
 *
 * Initializes leaflet maps handler with needed data.
 *
 * @param {object}              opt                                  object for initializing. Note that opt.data keys are based on data-attribute names
 *                                                                   and are not the same as the actual leaflet map option keys. The actual keys can be used
 *                                                                   via opt.options
 * @param {object}              opt.data
 * @param {string}              opt.data.id                          map dom container id
 * @param {string}              [opt.data.tilesPath]                 path for raster tiles. Fx. '/fileadmin/content/maps/testmap/'
 * @param {string|number}       [opt.data.width]                     width of generated raster tiles using fx. maptiler when fully zoomed. Required when using tilesPath
 * @param {string|number}       [opt.data.height]                    height of generated raster tiles using fx. maptiler when fully zoomed. Required when using tilesPath
 * @param {string|number}       [opt.data.centerLat]                 default center latitude of map
 * @param {string|number}       [opt.data.centerLng]                 default center longitude of map
 * @param {string|number}       [opt.data.minZoom]                   min zoom value of map. Required when using tilesPath
 * @param {string|number}       [opt.data.maxZoom]                   max zoom value of map. Required when using tilesPath
 * @param {string|number}       [opt.data.initialZoom]               initial zoom value of map
 * @param {bool|string|number}  [opt.data.hideZoom=false]            hide zoom controls
 * @param {bool|string|number}  [opt.data.disableDoubleClick=false]  disable zoom via doubleclick
 * @param {bool|string|number}  [opt.data.disableDragging=false]     disable dragging map via mouse/touch
 * @param {bool|string|number}  [opt.data.disableScrollZoom=false]   disable zoom via mouse scroll
 * @param {bool|string|number}  [opt.data.disableTouchZoom=false]    disable zoom via touch
 * @param {bool|string|number}  [opt.data.hideAttribution=false]     hide leaflet attribution link
 * @param {object}              [opt.options={}]                     additional {@link http://leafletjs.com/reference-1.2.0.html#map|map options},
 *                                                                   will override any existing options which were set via opt.data
 *
 * @example
 * import MapApiFactory from './map-api/leaflet/map-api-factory'
 *
 * // or MapApiFactory.create({data, options});
 * let mapHandler = MapApiFactory({
 *   data: {
 *     id: 'some-id',
 *     disableDragging: '1'
 *   },
 *   options: {
 *     dragging: true // overrides opt.data.disableDragging
 *   }
 * });
 *
 * mapHandler.addMap(); // adds map to DOM
 *
 */
/* harmony default export */ var leaflet_map_api_factory = (map_api_factory_MapApiFactory);
// CONCATENATED MODULE: ./src/frontend/js/map-api/leaflet/item-api-mixin.js



var leaflet_item_api_mixin_PrivilegedMethods = stampit_full_default()().init(function () {
  var itemObj = void 0,
      mapObj = void 0,
      infoWindowObj = void 0;

  /**
   *
   * Get item or return null if no item was created
   *
   * @memberOf MapApi/Leaflet/ItemApiMixin
   * @function getItem
   * @instance
   *
   * @return {object} leaflet item instance: marker (L.marker), polygon etc.
   */
  this.getItem = function () {
    return itemObj || null;
  };

  /**
   *
   * Set main item object
   *
   * @memberOf MapApi/Leaflet/ItemApiMixin
   * @function setItem
   * @instance
   *
   * @param {object} item leaflet item instance: marker, polygon etc.
   * @return {object} The instance on which this method was called
   */
  this.setItem = function (item) {
    itemObj = item;

    return this;
  };
});

var leaflet_item_api_mixin_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Add marker info window and click event listener
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @param {string} content html content
     * @param {object} [options={}] additional {@link http://leafletjs.com/reference-1.2.0.html#popup|popup options}
     *
     * @return {object} The instance on which this method was called
     */
    addInfoWindow: function addInfoWindow(content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var item = this.getItem(),
          mergedOptions = void 0;

      mergedOptions = Object.assign({
        content: content
      }, options);

      item.bindPopup(content, mergedOptions);

      return this;
    },

    /**
     *
     * Get infoWindow of item
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object|null} L.popup object instance
     */
    getInfoWindow: function getInfoWindow() {
      var item = this.getItem(),
          infoWindowObj = null;

      if (item) {
        infoWindowObj = item.getPopup();
      }

      return infoWindowObj;
    },

    /**
     *
     * Opens item window if one exists
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    openWindow: function openWindow() {

      this.getItem().openPopup();

      return this;
    },

    /**
     *
     * Closes item window if one exists
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    closeWindow: function openWindow() {
      var w = this.getInfoWindow();

      if (w) {
        w.closePopup();
      }

      return this;
    },

    /**
     *
     * Get map to which item is currently attached
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object|null} L.map object instance
     */
    getMap: function getMap() {
      var item = this.getItem(),
          map = void 0;

      if (item) {
        map = item.options.map;
      }

      return map || null;
    },

    /**
     *
     * Set map of item
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @param {object} L.map object instance
     *
     * @return {object} The instance on which this method was called
     */
    setMap: function setMap(map) {
      var item = this.getItem();

      if (item) {
        item.addTo(map);
      }

      return this;
    },

    /**
     *
     * Leaflet items do not offer a way to set options after
     * an instance is created, this method simply serves as
     * a notification to notify the user of this fact
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @see http://leafletjs.com/reference-1.2.0.html#marker
     *
     * @return void
     */
    setOptions: function setOptions(options) {
      var msg = 'setOptions method is not available for leaflet items,\ninstead check available setter methods for fx. markers\nhere: http://leafletjs.com/reference-1.2.0.html#marker';

      console.warn(msg);
    }
  }
});

var item_api_mixin_ItemApiMixin = stampit_full_default()(leaflet_item_api_mixin_PrivilegedMethods, leaflet_item_api_mixin_PublicMethods, leaflet_utils_mixin);

/**
 *
 * leaflet item api mixin created using stampit.
 *
 * Serves as base mixin for all leaflet map item type
 * factories like markers, polygons etc.
 *
 * @mixin MapApi/Leaflet/ItemApiMixin
 *
 * @example
 * import ItemApiMixin from './map-api/leaflet/item-api-mixin';
 *
 * // create new item type factory
 * let NewItemFactory = stampit(ItemApiMixin, SomeNewProps, SomeNewMethods)
 *
 * let newItemHandler = NewItemFactory.create()
 */
/* harmony default export */ var leaflet_item_api_mixin = (item_api_mixin_ItemApiMixin);
// CONCATENATED MODULE: ./src/frontend/js/map-api/leaflet/marker-api-factory.js



var leaflet_marker_api_factory_InitiateProps = stampit_full_default()({

  /**
   *
   * Creates leaflet maps marker
   *
   * @memberOf module:MapApi/Leaflet/MarkerApiFactory
   * @instance
   *
   * @ignore
   *
   * @param {object} opt object for initializing
   * @param {object} opt.data
   * @param {number} opt.data.lat      latitude
   * @param {number} opt.data.lng      longitude
   * @param {object} opt.data.map      map to attach marker to
   * @param {object} [opt.options={}]  additional {@link http://leafletjs.com/reference-1.2.0.html#marker|marker options}
   *
   * @return {object} The instance on which this method was called
   */
  init: function init(_ref, _ref2) {
    var data = _ref.data,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;
    var instance = _ref2.instance,
        stamp = _ref2.stamp,
        args = _ref2.args;

    var markerLatLng = void 0,
        marker = void 0,
        mergedOptions = void 0,
        defaultOptions = void 0;

    this.data = data;
    this.options = options;

    markerLatLng = this.createLatLng(data.lat, data.lng);

    defaultOptions = {
      map: data.map
    };

    // Create icon
    if (data.icon) {
      defaultOptions.icon = this.createIcon(data.icon);
    }

    mergedOptions = Object.assign(defaultOptions, options);

    marker = L.marker(markerLatLng, mergedOptions);

    this.setItem(marker);

    this.setMap(data.map);

    return this;
  },

  properties: {
    data: {},
    options: {}
  }
});

var leaflet_marker_api_factory_PublicMethods = stampit_full_default()({
  methods: {

    /**
     *
     * Get marker lat/lng position object
     *
     * @memberOf module:MapApi/Leaflet/MarkerApiFactory
     * @instance
     *
     * @return {object} L.latLng object instance
     */
    getPosition: function getPosition() {
      return this.getItem().getLatLng();
    },

    /**
     *
     * Set position of marker using options object
     *
     * @memberOf module:MapApi/Leaflet/MarkerApiFactory
     * @instance
     *
     * @param {object} options      lat/lng
     * @param {number} options.lat  latitude
     * @param {number} options.lng  longitude
     *
     * @return {object} The instance on which this method was called
     */
    setPosition: function setPosition(options) {
      var markerLatLng = this.createLatLng(options.lat, options.lng);

      this.getItem().setLatLng(markerLatLng);

      return this;
    },

    /**
     *
     * Creates icon for use in marker
     *
     * @memberOf module:MapApi/Leaflet/MarkerApiFactory
     * @instance
     *
     * @param {object}   options                    options object for configuring icon
     * @param {string}   options.iconUrl            url of icon
     * @param {string}   [options.iconRetinaUrl]    url of retina icon
     * @param {number[]} [options.iconSize]         natural width/height of non-retina icon, fx [40,80]
     * @param {number[]} [options.iconAnchor]       xy coordinates of marker anchor relative to icon, fx [20,40]
     * @param {number[]} [options.popupAnchor]      xy coordinates of popup anchor relative to marker anchor, fx [20,-40]
     * @param {string}   [options.shadowUrl]        url of shadow icon
     * @param {string}   [options.shadowRetinaUrl]  url of retina shadow icon
     * @param {number[]} [options.shadowSize]       natural width/height of non-retina shadow, fx [70,40]
     * @param {number[]} [options.shadowAnchor]     xy coordinates of shadow icon to use as anchor, fx [0,40]
     * @param {string}   [options.className]        class name for shadow and icon img tags
     *
     * @see http://leafletjs.com/reference-1.2.0.html#icon-l-icon
     *
     * @return {object} L.icon object instance
     */
    createIcon: function createIcon(options) {

      var icon = L.icon(options);

      return icon;
    },

    /**
     *
     * Set icon of marker
     *
     * @memberOf module:MapApi/Leaflet/MarkerApiFactory
     * @instance
     *
     * @param {object} options see {@link module:MapApi/Leaflet/MarkerApiFactory|createIcon method} for params
     *
     * @return {object} The instance on which this method was called
     */
    setIcon: function setIcon(options) {
      var icon = this.createIcon(options);

      this.getItem().setIcon(icon);

      return this;
    },

    /**
     *
     * Show item
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    show: function show() {
      this.getItem().setOpacity(1);

      return this;
    },

    /**
     *
     * Hide item
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {object} The instance on which this method was called
     */
    hide: function hide() {
      this.getItem().setOpacity(0);

      return this;
    },

    /**
     *
     * Checks if marker is hidden
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {bool} if marker is hidden or not
     */
    isHidden: function isHidden() {
      var hidden = this.getItem().options.opacity === 0;

      return hidden;
    },

    /**
     *
     * Checks if marker is visible
     *
     * @memberOf MapApi/Leaflet/ItemApiMixin
     * @instance
     *
     * @return {bool} if marker is visible or not
     */
    isVisible: function isVisible() {
      var visible = this.getItem().options.opacity > 0;

      return visible;
    }
  }

});

var marker_api_factory_MarkerApiFactory = stampit_full_default()(leaflet_item_api_mixin, leaflet_marker_api_factory_InitiateProps, leaflet_marker_api_factory_PublicMethods);

/**
 *
 * Leaflet marker api factory created using stampit
 *
 * @module MapApi/Leaflet/MarkerApiFactory
 * @mixes MapApi/Leaflet/ItemApiMixin
 *
 * @param {object} opt object for initializing
 * @param {object} opt.data
 * @param {number} opt.data.lat      latitude
 * @param {number} opt.data.lng      longitude
 * @param {object} opt.data.map      map to attach marker to
 * @param {object} [opt.data.icon]   see {@link module:MapApi/Leaflet/MarkerApiFactory#createIcon|createIcon method} for params
 * @param {object} [opt.options={}]  additional {@link http://leafletjs.com/reference-1.2.0.html#marker|marker options}
 *
 * @example
 * import MarkerApiFactory from './map-api/leaflet/marker-api-factory'
 *
 * // or MarkerApiFactory.create({data, options});
 * let markerHandler = MarkerApiFactory({
 *   data:{
 *     lat: markerData.lat,
 *     lng: markerData.lng,
 *     map: mapHandler.getMap(),
 *   }, options: {}
 * }).addInfoWindow(htmlString);
 */
/* harmony default export */ var leaflet_marker_api_factory = (marker_api_factory_MarkerApiFactory);
// CONCATENATED MODULE: ./src/frontend/js/app.js









// maps-factory reference, key is mapType
var mapsFactoryReference = {
  '1': map_api_factory,
  '2': leaflet_map_api_factory
};

// marker-factory reference, key is mapType
var markerFactoryReference = {
  '1': marker_api_factory,
  '2': leaflet_marker_api_factory
};

$(document).ready(function () {

  var outerMapDomEls = document.querySelectorAll('.js-multimaps-map-outer');

  // Use Array.prototype.slice.call as forEach on nodeList does
  // not work in IE11
  Array.prototype.slice.call(outerMapDomEls).forEach(function (outerMapEl) {

    var mapDomEl = outerMapEl.querySelector('.js-multimaps-map'),
        markers = outerMapEl.querySelectorAll('.js-map-marker'),
        data = mapDomEl.dataset,
        MapFactory = mapsFactoryReference[data.type],
        MarkerFactory = markerFactoryReference[data.type],
        collectionManager = void 0,
        allMarkersCollection = void 0,
        mapHandler = void 0,
        mapObj = void 0,
        markerToOpen = void 0,
        markerToCenterOn = void 0;

    // Create map handler instance, passing
    // needed options
    mapHandler = MapFactory.create({ data: data });

    // Create instance of collection manager
    collectionManager = collection_manager_factory.create();

    // Add new collection to manager
    allMarkersCollection = collectionManager.addCollection('markers');

    // Add map to DOM
    mapHandler.addMap();

    // get created map object
    mapObj = mapHandler.getMap();

    $(window).on('resize', function () {
      mapHandler.resize();
    });

    // Add markers
    Array.prototype.slice.call(markers).forEach(function (marker, x) {
      var markerData = marker.dataset,
          markerContent = marker.innerHTML,
          markerHandler = void 0,
          categoryCollection = void 0,
          iconObj = void 0;

      // If icon options were passed as json string
      if (markerData.icon) {
        iconObj = JSON.parse(markerData.icon);
      };

      // Create marker handler
      markerHandler = MarkerFactory.create({
        data: {
          lat: markerData.lat,
          lng: markerData.lng,
          map: mapObj,
          icon: iconObj
        }, options: {}
      });

      // Add infowindow if needed
      if (markerContent) {
        markerHandler.addInfoWindow(markerContent);
      }

      // Example of using collection manager to add
      // collections based on marker categories
      if (markerData.catId) {
        if (!collectionManager.collectionExists('cat_' + markerData.catId)) {
          categoryCollection = collectionManager.addCollection('cat_' + markerData.catId);
        } else {
          categoryCollection = collectionManager.getCollection('cat_' + markerData.catId);
        }

        categoryCollection.addItem(markerData.id, markerHandler);
      }

      // Add all markers to non-categorised collection
      allMarkersCollection.addItem(markerData.id, markerHandler);

      // Should a specific marker window be open?
      if (markerData.openInfo) {
        markerToOpen = markerHandler;
      }

      // // Should map be centered on a specific marker?
      if (markerData.center) {
        markerToCenterOn = markerHandler;
      }
    });

    if (markerToOpen) {
      mapHandler.onReady(function openMarkerOnReady() {
        markerToOpen.openWindow();
      });
    }

    if (markerToCenterOn) {
      mapHandler.onReady(function centerOn() {
        mapHandler.setCenter(markerToCenterOn.data.lat, markerToCenterOn.data.lng);
      });
    } else if (data.autofit === '1') {
      // Should map bounds be autofitted to markers?
      mapHandler.onReady(function centerOn() {
        mapHandler.fitToItems(allMarkersCollection.getAllItems());
      });
    } else {
      mapHandler.setCenter(data.centerLat, data.centerLng);
    }
  });
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/frontend/frontend.bundle.js